import React from 'react';
import Shimmer from './Shimmer';

const ProjectShimmer = () => {
    // Créer 3 éléments de projet pour le shimmer
    const projectItems = Array(3).fill(null);

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Projects Section Shimmer */}
            <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
                <div className="text-center mb-12">
                    <Shimmer className="h-10 w-64 mx-auto rounded mb-4"/>
                    <Shimmer className="h-6 w-96 mx-auto rounded"/>
                </div>

                <div className="space-y-8">
                    {projectItems.map((_, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100"
                        >
                            <div className="flex flex-col lg:flex-row">
                                {/* Image Section */}
                                <div className="lg:w-2/5 relative">
                                    <Shimmer className="h-64 lg:h-[300px] w-full"/>
                                    {/* Status Badge */}
                                    <div className="absolute top-4 right-4">
                                        <Shimmer className="h-8 w-24 rounded-full"/>
                                    </div>
                                </div>

                                {/* Content Section */}
                                <div className="lg:w-3/5 p-6 lg:p-8">
                                    {/* Title */}
                                    <Shimmer className="h-8 w-3/4 rounded mb-4"/>
                                    {/* Description */}
                                    <Shimmer className="h-4 w-full rounded mb-2"/>
                                    <Shimmer className="h-4 w-full rounded mb-2"/>
                                    <Shimmer className="h-4 w-2/3 rounded mb-6"/>

                                    {/* Status and Progress */}
                                    <div className="flex items-center gap-4">
                                        <div className="flex items-center gap-2">
                                            <Shimmer className="h-6 w-6 rounded-full"/>
                                            <Shimmer className="h-6 w-32 rounded"/>
                                        </div>
                                        <div className="flex-1">
                                            <Shimmer className="h-2 w-full rounded-full mb-2"/>
                                            <Shimmer className="h-4 w-20 rounded"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default ProjectShimmer;